<template>
  <v-container fluid class="fill-height d-block">
    <div class="pa-2 fill-height">
      <Loading v-if="loading" />

      <div v-else class="fill-height d-flex flex-column align-start">
        <v-btn
          color="primary"
          depressed
          class="mb-3"
          @click="addCategoryModal = true"
        >
          {{ $t("panel.businesses.businessCategories.add") }}
        </v-btn>

        <v-row class="overflow-auto fill-width" align-content="start">
          <v-col
            v-for="(category, index) in categories"
            :key="index"
            cols="12"
            sm="6"
            md="4"
            lg="3"
          >
            <v-card
              color="gray1"
              elevation="0"
              class="d-flex align-center justify-space-between align-content-start pa-3"
              height="48"
            >
              <div>
                {{ category.businessTypeName }}
              </div>

              <v-btn
                text
                :color="category.status === 'ACTIVE' ? 'error' : 'success'"
                depressed
                @click="openActivationModal(category)"
              >
                <span class="font-regular-10">
                  <template v-if="category.status === 'ACTIVE'">
                    {{ $t("panel.businesses.businessCategories.deActive") }}
                  </template>

                  <template v-else>
                    {{ $t("panel.businesses.businessCategories.active") }}
                  </template>
                </span>
              </v-btn>
            </v-card>
          </v-col>
        </v-row>
        <div v-if="categories.length" class="text-center pt-2 align-self-end">
          <v-pagination
            v-model="filtersObj.page"
            :length="totalPages"
            :total-visible="7"
            prev-icon="< Back"
            next-icon="Next >"
            class="pagination"
            @input="filtersSubmission(true)"
          />
        </div>

        <v-dialog v-model="addCategoryModal" max-width="450px">
          <v-btn icon :ripple="false" @click="addCategoryModal = false">
            <v-icon size="24">mdi-close</v-icon>
          </v-btn>

          <v-form @submit.prevent="addCategory" class="pa-6">
            <v-text-field
              v-model="categoryName"
              :label="$t('panel.businesses.businessCategories.name')"
              class="fill-width"
              outlined
              hide-details
            />

            <v-btn
              color="primary"
              class="py-6 font-semiBold-16 mt-8"
              depressed
              block
              type="submit"
            >
              {{ $t("panel.businesses.businessCategories.submit") }}
            </v-btn>
          </v-form>
        </v-dialog>

        <v-dialog v-model="activationModal" max-width="450px">
          <v-btn icon :ripple="false" @click="activationModal = false">
            <v-icon size="24">mdi-close</v-icon>
          </v-btn>

          <div class="pa-6 text-center">
            <div class="font-semiBold-16 mb-3">
              <span v-if="selectedItem.status === 'ACTIVE'" class="error--text">
                {{ $t("panel.businesses.businessCategories.deActive") }}
              </span>

              <span v-else class="success--text">
                {{ $t("panel.businesses.businessCategories.active") }}
              </span>
            </div>

            <div class="font-regular-14 mb-8">
              {{ $t("panel.businesses.businessCategories.sureToChangeStatus") }}
            </div>

            <div class="d-md-flex justify-md-space-between">
              <v-btn
                depressed
                outlined
                :block="$vuetify.breakpoint.mdAndDown"
                :color="selectedItem.status === 'ACTIVE' ? 'error' : 'success'"
                class="py-6 px-10 font-semiBold-16 mb-3 mb-md-0"
                @click="changeActivation"
              >
                {{ $t("panel.businesses.businessCategories.confirm") }}
              </v-btn>

              <v-btn
                depressed
                :block="$vuetify.breakpoint.mdAndDown"
                outlined
                color="gray7"
                class="py-6 px-10 font-semiBold-16"
                @click="activationModal = false"
              >
                {{ $t("panel.businesses.businessCategories.cancel") }}
              </v-btn>
            </div>
          </div>
        </v-dialog>
      </div>
    </div>
  </v-container>
</template>

<script>
import { merchantService } from "@/services";
import setFiltersQueries from "@/mixins/setFilters&Queries";
import Loading from "@/components/Common/Loading";

export default {
  name: "business-categories",
  components: { Loading },
  mixins: [setFiltersQueries],
  data() {
    return {
      loading: false,
      submitLoading: false,
      categories: [],
      addCategoryModal: false,
      activationModal: false,
      categoryName: "",
      selectedItem: {},
      totalPages: 1,
      shortList: false,
      filtersObj: {
        page: 1,
        size: 30
      }
    };
  },
  async mounted() {
    await this.$setFiltersFromQuery();
    await this.filtersSubmission(true);
  },
  methods: {
    async filtersSubmission(paginationButton) {
      await this.loadData(this.$setQueryFromFilters(paginationButton));
    },
    loadData(filters) {
      this.loading = true;
      merchantService
        .getMerchantTypes(filters)
        .then(response => {
          this.totalPages = response.data.data.totalPages;
          this.categories = response.data.data.content;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openActivationModal(item) {
      this.selectedItem = item;
      this.activationModal = true;
    },
    addCategory() {
      if (!this.categoryName) {
        return;
      }

      this.submitLoading = true;
      merchantService
        .addMerchantCategory({ name: this.categoryName })
        .then(res => {
          this.$toast.success(res.data.message);
          this.filtersSubmission();
          this.categoryName = "";
          this.addCategoryModal = false;
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },
    changeActivation() {
      this.submitLoading = true;
      const model = {
        businessTypeId: this.selectedItem.businessTypeId,
        status: this.selectedItem.status === "ACTIVE" ? "DEACTIVATE" : "ACTIVE"
      };
      merchantService
        .changeCategoryStatus(model)
        .then(res => {
          this.$toast.success(res.data.message);
          this.filtersSubmission(true);
          this.activationModal = false;
        })
        .finally(() => {
          this.submitLoading = false;
        });
    }
  }
};
</script>

<style scoped></style>
